import { Outlet } from "react-router-dom";
import SidebarLayout from "../../components/common/layout/SidebarLayout";
import { projectMenus } from "../../components/layout/ProjectMenus";

export default function ApprovalLayout() {
  const { title, base, sections } = projectMenus.approval;

  return (
    <SidebarLayout
      title={title}
      base={base}
      sections={sections}
    >
      <Outlet />
    </SidebarLayout>
  );
}
